var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footerpart",attrs:{"color":"white","inset":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}}),_c('div',{staticClass:"grey--text text--darken-2 text-center font-weight-bold"},[_vm._v("Prosecutor General's Office — © "+_vm._s(new Date().getFullYear()))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }